// extracted by mini-css-extract-plugin
export default {"card":"A6-z"};